import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "../components/Logo";
import { api } from "../lib/api";

const Shell = ({ children, testId }) => (
  <div className="grain grid-lines min-h-screen bg-[#07070b] px-5 py-8 md:px-10">
    <Link to="/"><Logo /></Link>
    <div className="mx-auto mt-20 max-w-xl border border-white/10 bg-[#0b0b11]/90 p-10 text-center" data-testid={testId}>{children}</div>
  </div>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) {
      setState("error");
      return undefined;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data?.payment_status === "paid") {
          navigate(`/order/${data.order_id}?k=${data.access_key}`, { replace: true });
          return;
        }
      } catch {
        setState("error");
        return;
      }
      tries += 1;
      if (tries < 10) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, navigate]);

  return (
    <Shell testId="payment-status-container">
      {state === "checking" && (<><Loader2 className="mx-auto h-8 w-8 animate-spin text-[#a259ff]" /><p className="mt-6 font-display text-5xl uppercase text-white">Confirming payment</p></>)}
      {state === "timeout" && <p className="text-slate-300">Payment is still processing. Check your email or contact us with your receipt.</p>}
      {state === "error" && <p className="text-slate-300">We couldn't verify this payment. Contact us if you were charged.</p>}
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell testId="payment-cancel-container">
      <p className="font-display text-5xl uppercase text-white">Payment cancelled</p>
      <p className="mt-4 text-slate-300">No charge was made. You can pick another account or payment method.</p>
      <Link to="/" className="mt-8 inline-block rounded-full bg-[#a259ff] px-6 py-3 font-mono text-xs font-bold uppercase tracking-widest text-black" data-testid="payment-cancel-back">Back to store</Link>
    </Shell>
  );
}
